import React, { Component } from 'react'
import PropTypes from 'prop-types'

import localization from './localization'

import styles from './CookieConsent.module.styl'

class CookieConsent extends Component {
  static propTypes = {
    cookies: PropTypes.object.isRequired,
    language: PropTypes.string
  }

  state = {
    cookieConsent: this.props.cookies.get('COOKIECONSENT')
  }

  _setCookie = (e) => {
    const date = new Date()
    date.setFullYear(date.getFullYear() + 10)

    this.props.cookies.set('COOKIECONSENT', 'true', { path: '/', expires: date })
    e.target.parentElement.classList.add(styles.consented)
  }

  render() {
    if (this.state.cookieConsent !== 'true') {
      return (
        <div className={styles.cookieConsent}>
          <span className={styles.innerText}>{localization[this.props.language]}</span>
          <button className={styles.innerButton} onClick={(e) => { this._setCookie(e) }}>×</button>
        </div>
      )
    }

    return null
  }
}

export default CookieConsent




// WEBPACK FOOTER //
// ./src/components/CookieConsent/CookieConsent.js